<template>
  <div class="page-container font_Montserrat">
    <div class="page-box">
      <div class="page-content-wrapper">
        <div class="page-content">
          <h2 class="text-uppercase font_size_1750rem font-weight-bold">
            Using Inform
          </h2>
          <div class="mt-4 font_size_1000rem font-weight-bold">
            <p>
              Inform allows you to create customized Reports of a
              specialty's crowdsourced data.
            </p>
            <p class="mb-0 font-weight-bold">From Inform, you can:</p>
          </div>
          <b-row class="padd-invite">
            <image-text
                v-for="item in popUpContent"
                :img-src="item.img"
                :text="item.text"
                :key="item.img"
            />
          </b-row>
          <div
              class="d-flex align-items-center justify-content-center mt-5"
          >
            <b-button
                variant="v2_main_dark_M"
                @click="gotoICO"
                class="text-uppercase"
            >
              Get Started
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImageText from '@/components/ImageText';
import ImageUrlMixin from '@/mixins/ImageUrlMixin';
import InfoPopupParentMixin from '@/mixins/InfoPopupParentMixin';

export default {
  name: 'PrePaywallRecruiterInform',
  mixins: [ImageUrlMixin, InfoPopupParentMixin],
  components: {
    ImageText,
  },
  data: function () {
    return {
      popUpContent: [
        {
          img: 'prepaywall/inform/review-data.svg',
          text:
              'Review crowdsourced compensation, productivity, and practice data from physicians in your specialty of interest.',
        },
        {
          img: 'prepaywall/inform/filter-icon.svg',
          text:
              'Use our crowdsourced market intelligence to shape your job opportunities and maximize their appeal to potential candidates.',
        },
        {
          img: 'prepaywall/inform/report-icon.svg',
          text:
              'Explore specialty-specific market trends for particular geographic regions of interest to you and your clients.',
        },
        {
          img: 'prepaywall/inform/aggregate-icon.svg',
          text:
              'Inform will not report aggregate information for any Measure with fewer than ten responses.',
        },
      ],
    };
  },
  mounted: function () {
    this.$root.$on('prepaywall::infopopup::show', this.showInfoPanelByButton);
  },
  beforeDestroy: function () {
    this.$root.$off('prepaywall::infopopup::show');
  },
  methods: {
    gotoICO: function () {
      //// Clear all before store ////
      this.$store.state.job_offer = undefined;
      this.$store.state.job_information = undefined;
      this.$store.state.show_payment_page = '';
      this.$store.state.is_new_offer = undefined;
      this.$store.state.location_zip_code = undefined;
      this.$store.state.specialtyId = undefined;
      
      this.$router.push('/recruiter/ico');
    }
  },
};
</script>

<style scoped lang="scss">
.page-container {
  margin: 0 auto;
  max-width: 1420px;
  position: relative;
  height: 100vh;
}

.page-content {
  padding: 3rem 6rem;
  background-color: #FFFFFF;
  min-width: 300px;
}

.page-box {
  background-image: url("/informBackground.png");
  background-size: 100%;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
}

.page-box-overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  background: #606060;
  opacity: 0.4;
  z-index: 10;
}

.page-content-wrapper {
  padding: 7rem 9rem;
  background-color: rgba(147, 147, 147, 0.8);
  width: 100%;
  height: 100%;
}

@media (min-width: 401px) and (max-width: 900px) {
  .page-content-wrapper {
    padding: 1rem;
  }
  .padd-invite {
    padding-bottom: 1rem;
  }
}

@media (min-width: 901px) and (max-width: 1200px) {
  .page-content-wrapper {
    padding: 3rem 4rem;
  }
}

@media (min-width: 320px) and (max-width: 584px) {
  .page-content {
    padding: 3rem 2rem;
  }
}

@media (min-width: 320px) and (max-width: 400px) {
  .page-content-wrapper {
    padding: 0.5rem;
  }
  .padd-invite {
    padding-bottom: 1rem;
  }
}
</style>
